const GfcIconDirective = function (Constants) {
    return {
        restrict: 'E',
        scope: {
            icon: '@',
            size: '@'
        },
        template: "<img ng-src=\"" + Constants.portalAppPath + "/content/images/modern/{{ icon }}.svg\" class=\"gfc_mui_img\" ng-style=\"{ height: size, width: size}\" />",

    }
};

GfcIconDirective.$inject = ["Constants"];

export { GfcIconDirective };